<template>
  <button type="button" class="btn btn-primary" @click="show = true">Mail Operator</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Operator Mail</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="">Mail Subject:</label>
            <input type="text" class="form-control" v-model="mail.subject">
          </div>

          <div class="mb-3">
            <label>Journeys</label>
            <select v-model="mail.operator" class="form-select" v-if="form.journeys.length > 1">
              <option value="">Select Journey</option>
              <option v-for="(journey, index) in form.journeys" :key="index" :value="journey.operator">
                {{ findOperator(journey.operator).name }} - {{ journey.trip == 'round' ? 'Roundtrip' : 'One way' }} - {{ findType(journey.type).name }}
              </option>
            </select>

            <select v-model="mail.operator" class="form-select" v-else>
              <option selected v-for="(journey, index) in form.journeys" :key="index" :value="journey.operator">
                {{ findOperator(journey.operator).name }} - {{ journey.trip == 'round' ? 'Roundtrip' : 'One way' }} - {{ findType(journey.type).name }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label>Inserts</label>
            <div class="form-check" v-for="Insert in getInserts()" :key="Insert.id">
              <input class="form-check-input" type="checkbox" :value="Insert.id" :id="Insert.id" v-model="mail.inserts">
              <label class="form-check-label" :for="Insert.id">
                {{ Insert.name }}
              </label>
            </div>
          </div>

          <div class="mb-3">
            <label for="">Mail body:</label>
            <editor
            api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
              v-model="mail.body"
              :init="{
                height: 300,
                menubar: false,
                plugins: ['lists', 'link', 'code'],
                toolbar:
                  'undo redo | styles | forecolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link code'
              }"
            />
          </div>
          <div class="mb-3">
            <label for="">Available tags:</label>
            <div class="tags">
              <span class="tag" v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="sendMail()">Send Mail</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash/throttle'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'OperatorMail',
  components: {
    Editor
  },
  props: ['bookings', 'form', 'mail_inserts'],
  data() {
    return {
      show: false,
      mail: this.$inertia.form({
        subject: null,
        body: null,
        inserts: [],
        template: null,
        operator: null,
      }),
      tags: [
        '{{ operator_name }}',
        '{{ operator_contact_name }}',
        '{{ booking_number }}',
        '{{ ticket_count }}',
        '{{ passengers }}',
        '{{ itinerary }}',
      ]
    }
  },
  mounted() {
    this.getJourneys()
  },
  methods: {
    getJourneys() {
      if (this.form.journeys > 1) {
        return this.form.journeys;
      } else {
        this.mail.operator = this.form.journeys[0].operator

        return this.form.journeys;
      }
    },
    getInserts() {
      let inserts = this.mail_inserts.filter(obj => {
        return obj.group === 'operator'
      })
      return inserts
    },
    findAirport(airportId) {
      return this.$parent.airports.filter(function(item){
          if(item.id == airportId) return item;
      })[0]
    },
    findOperator(operatorId) {
      return this.$parent.operators.filter(function(item){
          if(item.id == operatorId) return item;
      })[0]
    },
    findType(typeId) {
      return this.$parent.types.filter(function(item){
          if(item.id == typeId) return item;
      })[0]
    },
    sendMail() {
        this.mail.put(`/bookings/${this.bookings.id}/mail-operator`)
        this.show = false
    },
  }
}
</script>

<style>

</style>
